import { Bar, mixins } from "vue-chartjs";
import Chart from "chart.js";
import { roundedBars } from "./roundedBars";

Chart.elements.Rectangle.prototype.draw = roundedBars;
Chart.defaults.global.defaultFontFamily = "Open Sans";
Chart.defaults.global.defaultFontSize = 13;
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.responsive = true;

const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  chartData: {},
  props: ["options"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.chartData.datasets.forEach(elem => {
      elem.label = elem.label.split('-')[0]
    })
    this.renderChart(this.chartData, this.options);
  }
};
